<template>
	<div class="appimpactdetail">
		<div class="container">
			<div class="content-column">
				<img :src="impactDetail.featured_image" class="detail_image" />
			</div>
			<div class="content-column">
				<div class="event_title">
					<h3>{{ impactDetail.post_title }}</h3>
					<h4>{{ impactDetail.subtitle }}</h4>
				</div>
				<div class="event_detail">
					<p v-html="impactDetail.post_content"></p>
					<router-link to="/impact?detail=true" class="readmore"
						>Back to Our Impact</router-link
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			wpData: wpData,
			impactDetail: {}
		};
	},
	mounted() {
		fetch(
			`${this.wpData.rest_url}/wp/v2/postdatabytitle?post_name=our_work&post_id=${this.$route.params.id}`
		)
			.then(res => res.json())
			.then(data => {
				this.impactDetail = data;
				console.log(data);
			});
	},
	methods: {
		gotoMenuPage: function(event) {
			alert("Event1");
		}
	}
};
</script>

<style>
.appimpactdetail {
	position: relative;
	width: 100%;
	min-height: calc(100vh - 100px);
	padding: 50px 0;
	background: #fff;
	color: #172c62;
}
.appimpactdetail .container {
	display: flex;
	flex-wrap: wrap;
	opacity: 0;
	animation-duration: 2s;
	animation-name: fade;
	animation-fill-mode: forwards;
	justify-content: space-between;
}
.appimpactdetail .content-column {
	width: calc(50% - 10px);
}
.appimpactdetail .content-column img {
	max-width: 100%;
}
.appimpactdetail .container .event_title {
	text-align: left;
	font-family: brandingsemibold;
}
.appimpactdetail .container .event_title h3 {
	font-size: 30px;
}
.appimpactdetail .container .event_title h4 {
	font-size: 24px;
	margin: 0;
	padding: 0;
}
.appimpactdetail .container .event_detail {
	padding-top: 30px;
	text-align: left;
}
.appimpactdetail .container .event_detail img {
	width: 360px;
	margin-right: 20px;
	float: left;
}
.appimpactdetail .container .event_detail p {
	font-size: 18px;
}
.appimpactdetail .container .event_detail ul {
	padding-left: 20px;
}
.appimpactdetail .container .event_detail ul li {
	margin: 0 0 10px;
	position: relative;
}
.appimpactdetail .container .event_detail ul li::before {
	content: "";
	position: absolute;
	height: 7px;
	top: 11px;
	left: -15px;
	width: 7px;
	background: #172c62;
	border-radius: 50%;
}
.appimpactdetail .readmore {
	width: 240px;
	height: 35px;
	font-size: 20px;
	padding: 0;
	background: none;
	color: #172c62;
	border: 1px solid #172c62;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 20px auto;
	text-decoration: none;
	transition: all 0.2s ease-in-out;
}
.appimpactdetail .readmore:hover {
	background: #172c62;
	color: #fff;
}
@keyframes fade {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}
@media (max-width: 767px) {
	.appimpactdetail .content-column {
		width: 100%;
		margin-bottom: 30px;
	}
	.appimpactdetail .content-column:last-child {
		margin-bottom: 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/AppImpactDetail.vue